import { useEffect, useRef } from "react";
import type { ShiftProductionFormListItem } from "../../../shared/shift-production-form/contracts";
import { shiftLabels } from "./line-options";

export function OperatorRecentFormsDialog({
  open,
  items,
  busy,
  error,
  onClose,
  onRetry,
  onEdit,
  hasPrevious = false,
  hasNext = false,
  onPrevious,
  onNext,
}: {
  hasPrevious?: boolean;
  hasNext?: boolean;
  onPrevious?: () => void;
  onNext?: () => void;
  open: boolean;
  items: ShiftProductionFormListItem[];
  busy: boolean;
  error: string | null;
  onClose: () => void;
  onRetry: () => void;
  onEdit: (form: ShiftProductionFormListItem) => void;
}) {
  const ref = useRef<HTMLDialogElement>(null);
  useEffect(() => {
    const dialog = ref.current;
    if (!dialog) return;
    if (open && !dialog.open) dialog.showModal();
    if (!open && dialog.open) dialog.close();
    return () => {
      if (dialog.open) dialog.close();
    };
  }, [open]);
  return (
    <dialog
      ref={ref}
      className="shift-pin-dialog shift-recent-forms-dialog"
      aria-labelledby="shift-recent-title"
      aria-describedby="shift-recent-description"
      onCancel={(event) => {
        event.preventDefault();
        if (!busy) onClose();
      }}
    >
      <h2 id="shift-recent-title">Gönderdiğim formları düzenle</h2>
      <p id="shift-recent-description">
        Kendi kayıtlarınızda düzeltme yapabilirsiniz. Önceki gönderimler ve onaylar
        geçmişte korunur; değişiklikleri yeniden onaya gönderirsiniz.
        Tarih, vardiya veya makine değişikliği için yönetici izni gerekir.
      </p>
      {error ? (
        <div className="shift-recent-error" role="alert">
          <p>{error}</p>
          <button type="button" disabled={busy} onClick={onRetry}>
            Yeniden dene
          </button>
        </div>
      ) : busy ? (
        <p role="status">İşleniyor…</p>
      ) : items.length === 0 ? (
        <p className="shift-recent-empty">Düzenleyebileceğiniz gönderilmiş formunuz yok.</p>
      ) : (
        <ul className="shift-recent-forms-list">
          {items.map((form) => (
            <li key={form.id}>
              <div>
                <strong>{form.formNo}</strong>
                <span>
                  {form.lineName} · {form.productionDate} ·{" "}
                  {form.shift ? shiftLabels[form.shift] : ""}
                </span>
                <span>
                  {form.status === "DRAFT" || form.status === "RETURNED" ? "Düzeltme taslağı" : form.status === "COMPLETED" ? "Onaylandı" : "Onay bekliyor"}
                </span>
              </div>
              <button
                type="button"
                disabled={busy}
                onClick={() => onEdit(form)}
              >
                {form.status === "DRAFT" || form.status === "RETURNED" ? "Düzeltmeye devam et" : "Düzeltme yap"}
              </button>
            </li>
          ))}
        </ul>
      )}
      <div className="shift-pin-dialog-actions">
        {hasPrevious ? (
          <button type="button" disabled={busy} onClick={onPrevious}>
            Önceki
          </button>
        ) : null}
        {hasNext ? (
          <button type="button" disabled={busy} onClick={onNext}>
            Sonraki
          </button>
        ) : null}
        <button type="button" autoFocus disabled={busy} onClick={onClose}>
          Forma dön
        </button>
      </div>
    </dialog>
  );
}
